import type { PermissionType } from "@/shared/types/PermissionType"

export const hasAnyPermissions = (permissions: PermissionType): boolean => {
  return Object.values(permissions).some((value) => Array.isArray(value) && value.length > 0)
}
